<template>
  <div >
    <div v-if="spinner">
      <div class="centered">
        <a-spin />
      </div>
    </div>
    <div v-if="orderItems.length > 0">
      <div class="row my-2">
        <div class="row my-4">
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 form-inline">
            <b>Records per Screen</b>
            <b-form-select
              class="mx-2"
              v-model="filterRecordsPerScreen"
              :options="filterRecordsPerScreenOptions"
              @change="onChangeRecordsPerScreen()"
            ></b-form-select>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-right">
            <h6>
              <span class="text-success">{{
                getBatchProcessSavedSearchPagination.totalRecords
              }}</span>
              RECORDS FOUND
            </h6>
          </div>
        </div>
        <b-table responsive :items="orderItems" :fields="savedSearchFields">
          <template v-slot:cell(batch_number)="data">
            <b-link
              @click="
                loadBatchProcessViewBatch(
                  data.item.batch_number,
                  data.item.created,
                  data.item.handled,
                  data.item.batch_type
                )
              "
              >{{ data.item.batch_number }}</b-link
            >
          </template>
          <template v-slot:cell(batch_type)="data">
            <span v-html="data.item.batch_type"></span>
          </template>
          <template v-slot:cell(created)="data">
            <p>
              {{
                data.item.created
                  ? moment(data.item.created + "Z").format("MM-DD-YYYY") +
                    " @ " +
                    moment(data.item.created + "Z").format("hh:mm A")
                  : ""
              }}
            </p>
          </template>
          <template v-slot:cell(handled)="data">
            <p>
              {{
                data.item.handled
                  ? moment(data.item.handled + "Z").format("MM-DD-YYYY")
                  : ""
              }}
            </p>
          </template>
          <template v-slot:cell(fax)="data">
            <router-link
              :to="{
                name: 'faxComponent',
                query: { batchNo: data.item.batch_number },
              }"
              target="_blank"
            >
              <font-awesome-icon class="icon-list" icon="file-alt" />
            </router-link>
          </template>
          <template v-slot:cell(email)="data">
            <router-link
              :to="{
                name: 'faxComponent',
                query: { batchNo: data.item.batch_number, isEmail: true },
              }"
              target="_blank"
            >
              <font-awesome-icon
                class="icon-list"
                :icon="
                  data.item.sent_by_email == '1' ? 'envelope-open' : 'envelope'
                "
              />
            </router-link>
          </template>
          <template v-slot:cell(DB)="data">
            <!-- <p>{{ data.item.DB }}</p> -->
          </template>
          <template v-slot:cell(Q_DB)="data">
            <!-- <p>{{ data.item.Q_DB }}</p> -->
          </template>
          <template v-slot:cell(delete)="data">
            <b-link
              @click="deleteBatchById(data.item.batch_number)"
              style="color: red"
            >
              <font-awesome-icon class="icon-list" icon="trash" />
            </b-link>
          </template>
        </b-table>
      </div>
      <div class="row my-2">
        <div class="col-xs-12 col-sm-12 col-lg-6 col-md-6">
          <label
            >Viewing
            {{
              filterRecordsPerScreen *
                getBatchProcessSavedSearchPagination.pageNo -
                filterRecordsPerScreen +
                1
            }}
            -
            {{
              filterRecordsPerScreen *
                getBatchProcessSavedSearchPagination.pageNo <=
              getBatchProcessSavedSearchPagination.totalRecords
                ? filterRecordsPerScreen *
                  getBatchProcessSavedSearchPagination.pageNo
                : getBatchProcessSavedSearchPagination.totalRecords
            }}
            of {{ getBatchProcessSavedSearchPagination.totalRecords }} records
          </label>
        </div>
        <div class="col-sm-12 col-lg-6 col-md-6">
          <b-button-group class="float-right">
            <b-button
              @click="firstPagination()"
              :disabled="
                firstPage === getBatchProcessSavedSearchPagination.pageNo
              "
              >&#60;&#60;</b-button
            >
            <b-button
              @click="prevPagination()"
              :disabled="
                firstPage === getBatchProcessSavedSearchPagination.pageNo
              "
              >Prev</b-button
            >
            <b-button>{{
              getBatchProcessSavedSearchPagination.pageNo
            }}</b-button>
            <b-button
              @click="nextPagination()"
              :disabled="
                Math.ceil(
                  getBatchProcessSavedSearchPagination.totalRecords /
                    filterRecordsPerScreen
                ) === getBatchProcessSavedSearchPagination.pageNo
              "
              >Next</b-button
            >
            <b-button
              @click="lastPagination()"
              :disabled="
                Math.ceil(
                  getBatchProcessSavedSearchPagination.totalRecords /
                    filterRecordsPerScreen
                ) === getBatchProcessSavedSearchPagination.pageNo
              "
              >>></b-button
            >
          </b-button-group>
        </div>
      </div>
    </div>
    <div
      v-else
      class="p-4 my-2 text-center"
      :class="{
        border: orderItems.length > 0 ? false : true,
      }"
    >
      <p>{{ getTableStatus }}</p>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { convertToDayMonthYear } from "@/utilities/date.js";

export default {
  name: "BatchProcessSavedSearch",
  data() {
    return {
      savedSearchFields: [
        {
          key: "batch_number",
          sortable: true,
          thStyle: { minWidth: '8rem'}
        },
        {
          key: "batch_type",
          sortable: true,
          thStyle: { minWidth: '8rem'}
        },
        {
          key: "created",
          sortable: true,
          thStyle: { minWidth: '12rem'}
        },
        {
          key: "handled",
          sortable: true,
          thStyle: { minWidth: '7rem'}
        },
        {
          key: "fax",
          sortable: false,
          thStyle: { minWidth: '5rem'}
        },
        {
          key: "email",
          sortable: true,
          thStyle: { minWidth: '5rem'}
        },
        {
          key: "DB",
          sortable: false,
          thStyle: { minWidth: '5rem'}
        },
        {
          key: "Q_DB",
          sortable: false,
          thStyle: { minWidth: '5rem'}
        },
        {
          key: "delete",
          sortable: false,
          thStyle: { minWidth: '5rem'}
        },
      ],
      filterRecordsPerScreen: 3,
      firstPage: 1,
      spinner: false,
      orderItems: [],
    };
  },
  methods: {
    firstPagination() {
      this.pageNo = 1;
      this.onChangeRecordsPerScreen();
    },
    prevPagination() {
      this.pageNo--;
      this.onChangeRecordsPerScreen();
    },
    nextPagination() {
      this.pageNo++;
      this.onChangeRecordsPerScreen();
    },
    lastPagination() {
      this.pageNo = Math.ceil(
        this.getBatchProcessSavedSearchPagination.totalRecords /
          this.filterRecordsPerScreen
      );
      this.onChangeRecordsPerScreen();
    },
    getBatchProcessSavedSearch(params) {
      this.$store.commit("batchProcess/SET_VIEW_BATCH_MESSAGE", {
        message: "",
        color: "",
      });

      this.$store
        .dispatch("batchProcess/fetchBatchProcessSavedSearch", params)
        .then(() => {
          this.spinner = false;
          this.$store.commit(
            "batchProcess/SET_TABLE_STATUS",
            "No records found"
          );
        })
        .catch(() => {
          this.spinner = false;
          console.log("error occured from batch process saved search");
        });
    },
    onChangeRecordsPerScreen() {
      this.spinner = true;
      this.orderItems = [];
      this.$store.commit("batchProcess/SET_TABLE_STATUS", "Processing");

      this.$store.commit("batchProcess/SET_VIEW_BATCH_MESSAGE", {
        message: "",
        color: "",
      });

      if (
        this.pageNo >
        Math.ceil(
          this.getBatchProcessSavedSearchPagination.totalRecords /
            this.filterRecordsPerScreen
        )
      ) {
        this.pageNo = 1;
      }

      var params = {
        daysback: this.getBatchProcessSavedSearchDaysBack,
        pg_num: this.pageNo,
        pg_size: this.filterRecordsPerScreen,
      };

      this.getBatchProcessSavedSearch(params);
    },
    deleteBatchById(batchId) {
      this.spinner = true;

      this.$store.commit("batchProcess/SET_VIEW_BATCH_MESSAGE", {
        message: "",
        color: "",
      });

      this.$store
        .dispatch("batchProcess/deleteBatchById", {
          batchNumber: batchId,
        })
        .then(() => {
          this.spinner = false;
          this.getBatchProcessSavedSearch({
            daysback: this.getBatchProcessSavedSearchDaysBack,
            pg_num: 1,
            pg_size: this.filterRecordsPerScreen,
          });
          this.scrollToTop();
        })
        .catch(() => {
          this.spinner = false;
          console.log("error occured from batch process delete batch");
        });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    loadBatchProcessViewBatch(batchNumber, createdDate, handleDate, batchName) {
      this.$store.commit("batchProcess/SET_TABLE_STATUS", "Processing");

      // setting batch process save search redirection to true
      this.$store.commit(
        "batchProcess/SET_BATCH_PROCESS_IS_SAVE_SEARCH_REDIRECT",
        {
          redirect: true,
          showOrderDetails: {
            batchNumber: batchNumber.toString(),
            createdDate: createdDate,
            handleDate: handleDate,
            batchName,
          },
        }
      );

      // setting msg to blank
      this.$store.commit("batchProcess/SET_VIEW_BATCH_UPDATE_MESSAGE", {
        message: "",
        color: "",
      });

      //setting new msg to blank
      this.$store.commit("batchProcess/SET_BATCH_MESSAGE", {
        message: "",
        color: "",
      });

      // brought store params, and updating batch number
      var params = {};

      params.batch_number = batchNumber.toString();

      // mutated new params to store
      this.$store.commit("batchProcess/SET_VIEW_BATCH_STORE_PARAMS", params);

      // created new params for fetch all view batch list api
      var new_params = {
        bodyParams: params,
        params: {
          pg_num: this.viewBatchPagination.pageNo,
          pg_size: this.viewBatchPagination.pageSize,
        },
      };

      this.$router.push({
        name: "BatchProcessViewBatch",
      });

      this.$store
        .dispatch("batchProcess/fetchAllViewBatchList", new_params)
        .then(() => {
          // setting batch process save search redirection to true
          this.$store.commit(
            "batchProcess/SET_TABLE_STATUS",
            "No records found"
          );
          this.$store.commit(
            "batchProcess/SET_BATCH_PROCESS_IS_SAVE_SEARCH_REDIRECT",
            {
              redirect: false,
              showOrderDetails: {
                batchNumber: batchNumber.toString(),
                createdDate: createdDate,
                handleDate: handleDate,
                batchName,
              },
            }
          );
        })
        .catch(() => {
          console.log("error occured from batch process form view batch");
        });
    },
  },

  computed: {
    getBatchProcessSavedSearchList() {
      return this.$store.getters["batchProcess/getBatchProcessSavedSearchList"];
    },
    getBatchProcessSavedSearchPagination() {
      return this.$store.getters[
        "batchProcess/getBatchProcessSavedSearchPagination"
      ];
    },
    getBatchProcessSavedSearchDaysBack() {
      return this.$store.getters[
        "batchProcess/getBatchProcessSavedSearchDaysBack"
      ];
    },
    filterRecordsPerScreenOptions() {
      return this.$store.getters[
        "batchProcess/getFilterRecordsPerScreenOptions"
      ];
    },
    viewBatchPagination() {
      return this.$store.getters["batchProcess/getViewBatchPagination"];
    },
    getBatchMessage() {
      return this.$store.getters["batchProcess/getBatchMessage"];
    },
    getTableStatus() {
      return this.$store.getters["batchProcess/getTableStatus"];
    },
  },
  watch: {
    getBatchProcessSavedSearchList(getBatchProcessSavedSearchList) {
      var datas = getBatchProcessSavedSearchList.map(function(data) {
        return {
          batch_number: data.batch_number,
          batch_type: data.batch_type,
          created: data.created_on ? data.created_on : "",
          created: data.created_on ? data.created_on : "",
          handled: data.date_handled ? data.date_handled : "",
          fax: "",
          email: data.sent_by_emai,
          sent_by_email: data.sent_by_email,
          DB: data.db,
          Q_DB: data.qdb,
        };
      });
      this.orderItems = datas;
    },
    getBatchProcessSavedSearchPagination(getBatchProcessSavedSearchPagination) {
      this.filterRecordsPerScreen =
        getBatchProcessSavedSearchPagination.pageSize;
      this.pageNo = getBatchProcessSavedSearchPagination.pageNo;
    },
  },
  created() {
    this.spinner = true;
    this.scrollToTop();
    this.getBatchProcessSavedSearch({
      daysback: this.getBatchProcessSavedSearchDaysBack,
      pg_num: 1,
      pg_size: this.filterRecordsPerScreen,
    });
    this.$store.commit("batchProcess/SET_VIEW_BATCH_UPDATE_MESSAGE", {
      message: "",
      color: "",
    });
    this.$store.commit("batchProcess/SET_TABLE_STATUS", "Processing");
  },
};
</script>
<style lang="scss" scoped>
form {
  border: 1px solid #ccc;
  padding: 25px;
  border-radius: 5px;
}

.form-switch .form-check-input {
  width: 3em;
  height: 1.3rem;
  margin-left: -1.5em !important;
}

.table-active {
  opacity: 0.5;
}

.centered {
  position: fixed;
  top: 50%;
  left: 63%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
}
</style>
